module.exports = __webpack_public_path__ + "static/media/mastercard.d0e6c022.svg";


//////////////////
// WEBPACK FOOTER
// ./src/blocks/footer/components/Info/static/img/mastercard.svg
// module id = 2065
// module chunks = 118